import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "is-flex is-justify-content-space-between is-align-items-center" }
const _hoisted_2 = { class: "list-table-container" }
const _hoisted_3 = { class: "is-flex is-align-items-center" }
const _hoisted_4 = {
  key: 1,
  class: "is-flex is-align-items-center"
}
const _hoisted_5 = { class: "control is-flex is-align-items-center" }
const _hoisted_6 = { class: "has-text-centered mt-4 mb-4" }
const _hoisted_7 = {
  class: "modal-card",
  style: {"width":"640px","max-width":"95vw"}
}
const _hoisted_8 = { class: "modal-card-head" }
const _hoisted_9 = { class: "modal-card-title" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "modal-card-body" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "modal-card-foot" }
const _hoisted_14 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_breadcrumb_item = _resolveComponent("b-breadcrumb-item")!
  const _component_b_breadcrumb = _resolveComponent("b-breadcrumb")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_table_column = _resolveComponent("b-table-column")!
  const _component_b_icon = _resolveComponent("b-icon")!
  const _component_b_tooltip = _resolveComponent("b-tooltip")!
  const _component_b_table = _resolveComponent("b-table")!
  const _component_b_select = _resolveComponent("b-select")!
  const _component_b_field = _resolveComponent("b-field")!
  const _component_b_input = _resolveComponent("b-input")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_b_breadcrumb, {
        size: "is-large",
        separator: "has-succeeds-separator",
        "aria-label": "breadcrumbs"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_b_breadcrumb_item, { active: "" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('integrations.title')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_b_button, {
        type: "is-primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'integration-gallery' })))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('integrations.addNew')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_b_table, {
        data: _ctx.rows,
        striped: "",
        loading: _ctx.loading,
        onClick: _ctx.handleRowClick,
        "sort-icon": "menu-up",
        "default-sort": "name",
        "default-sort-direction": "asc"
      }, {
        empty: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('integrations.noneYet')), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_b_table_column, {
            field: "name",
            sortable: "",
            label: _ctx.$t('integrations.name')
          }, {
            default: _withCtx((props) => [
              _createTextVNode(_toDisplayString(props.row.name), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_b_table_column, {
            field: "type",
            sortable: "",
            label: _ctx.$t('integrations.type')
          }, {
            default: _withCtx((props) => [
              _createElementVNode("span", _hoisted_3, [
                _createVNode(_component_b_tooltip, {
                  label: _ctx.getTemplateLabel(props.row.type),
                  position: "is-right"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_icon, {
                      icon: _ctx.getTemplateIcon(props.row.type),
                      class: "mr-2"
                    }, null, 8, ["icon"])
                  ]),
                  _: 2
                }, 1032, ["label"])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_b_table_column, {
            field: "url",
            sortable: "",
            label: _ctx.$t('integrations.urlOrLanguage')
          }, {
            default: _withCtx((props) => [
              (props.row.url)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(props.row.url), 1)
                  ], 64))
                : (props.row.language)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                      _createVNode(_component_b_icon, {
                        icon: _ctx.getLanguageIcon(props.row.language),
                        class: "mr-2"
                      }, null, 8, ["icon"]),
                      _createTextVNode(" " + _toDisplayString(_ctx.getLanguageLabel(props.row.language)), 1)
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(" — ")
                    ], 64))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_b_table_column, {
            field: "disabled",
            sortable: "",
            label: _ctx.$t('integrations.status')
          }, {
            default: _withCtx((props) => [
              _createTextVNode(_toDisplayString(!props.row.disabled ? _ctx.$t('integrations.enabled') : _ctx.$t('integrations.disabled')), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_b_table_column, {
            label: _ctx.$t('global.action')
          }, {
            default: _withCtx((props) => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_b_button, {
                  type: "is-info",
                  size: "is-small",
                  "icon-left": "play",
                  title: _ctx.$t('integrations.test'),
                  "aria-label": "test",
                  class: "mr-2",
                  onClick: _withModifiers(($event: any) => (_ctx.openTestModal(props.row)), ["stop"])
                }, null, 8, ["title", "onClick"]),
                _createVNode(_component_b_button, {
                  type: "is-danger",
                  size: "is-small",
                  "icon-left": "delete",
                  title: _ctx.$t('global.delete'),
                  "aria-label": "delete",
                  onClick: _withModifiers(($event: any) => (_ctx.confirmRemove(props.row)), ["stop"])
                }, null, 8, ["title", "onClick"])
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data", "loading", "onClick"])
    ]),
    _createVNode(_component_b_modal, {
      modelValue: _ctx.testModalOpen,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.testModalOpen) = $event)),
      "has-modal-card": "",
      "trap-focus": "",
      "destroy-on-hide": false,
      "aria-role": "dialog",
      "can-cancel": ['escape','x','outside'],
      "aria-label": _ctx.$t('integrations.testWebhook'),
      "close-button-aria-label": "Close",
      "aria-modal": ""
    }, {
      default: _withCtx((props) => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("header", _hoisted_8, [
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('integrations.testWebhook')), 1),
            _createElementVNode("button", {
              class: "delete",
              "aria-label": "close",
              onClick: props.close
            }, null, 8, _hoisted_10)
          ]),
          _createElementVNode("section", _hoisted_11, [
            _createVNode(_component_b_field, {
              label: _ctx.$t('integrations.device')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_b_select, {
                  modelValue: _ctx.testDeviceId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.testDeviceId) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deviceList, (d) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: d.id,
                        value: d.id
                      }, _toDisplayString(d.name || d.id), 9, _hoisted_12))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_b_field, {
              label: _ctx.$t('integrations.eventData')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_b_input, {
                  type: "textarea",
                  rows: 6,
                  modelValue: _ctx.testEventData,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.testEventData) = $event)),
                  placeholder: _ctx.$t('integrations.eventDataPlaceholder')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("footer", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_b_button, {
                type: "is-primary",
                disabled: !_ctx.testDeviceId,
                onClick: _ctx.publishTestEvent
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('integrations.test')), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]),
              _createVNode(_component_b_button, {
                onClick: props.close
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('global.close')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "aria-label"])
  ]))
}